<template>
  <div class="pr-app">
    <MerchantSidebar />
    <main class="pr-main">
      <MerchantTopbar @open-notifications="openNotifications" />
      <slot />
    </main>
    <NotificationCenterDrawer v-if="notificationsOpen" @close="notificationsOpen = false" />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";

import { useNotificationsStore } from "../../features/notifications/store.js";
import NotificationCenterDrawer from "../../features/notifications/components/NotificationCenterDrawer.vue";
import MerchantSidebar from "./MerchantSidebar.vue";
import MerchantTopbar from "./MerchantTopbar.vue";

const notificationsOpen = ref(false);
const notifications = useNotificationsStore();

onMounted(() => {
  void notifications.loadAttentionNotifications();
});

function openNotifications(): void {
  notificationsOpen.value = true;
  void notifications.loadAttentionNotifications();
}
</script>
